
import { Suspense, useEffect, useRef, useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import Header from './ui/Header';
import Footer from './ui/Footer';
import Router from './Router';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
}

function RouteTransitionLoader() {
  const location = useLocation();
  const isFirstRender = useRef(true);
  const [isRouteLoading, setIsRouteLoading] = useState(false);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }

    setIsRouteLoading(true);
    const timeoutId = window.setTimeout(() => {
      setIsRouteLoading(false);
    }, 800);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.pathname]);

  if (!isRouteLoading) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[130]">
      <LoadingScreen />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteTransitionLoader />
      <Header />
      <Suspense fallback={<LoadingScreen />}>
        <Router />
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
